import { useMemo } from "react"

const LENSES = [
  { id: "domain", label: "Domain", shortcut: "⌘1" },
  { id: "behavior", label: "Behavior", shortcut: "⌘2" },
  { id: "data", label: "Data", shortcut: "⌘3" },
]

export default function LensSelector({ activeLens, onChange }) {
  const buttons = useMemo(() => {
    return LENSES.map((lens) => {
      const active = activeLens === lens.id
      return (
        <button
          key={lens.id}
          type="button"
          className={`lens-btn ${active ? "active" : ""}`}
          onClick={() => onChange(lens.id)}
          title={lens.shortcut}
        >
          <span className="lens-label">{lens.label}</span>
          <span className="lens-shortcut">{lens.shortcut}</span>
        </button>
      )
    })
  }, [activeLens, onChange])

  return <div className="lens-selector">{buttons}</div>
}

export { LENSES }
